/* Maison Patte — lightweight interactions (no dependencies) */
(function () {
  var root = document.documentElement;
  root.classList.add('mp-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-mp-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  }

  function initParallax() {
    if (reduce) return;
    var items = [].slice.call(document.querySelectorAll('[data-mp-parallax]'));
    if (!items.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-mp-parallax')) || 0.08;
        var offset = (r.top + r.height / 2 - vh / 2) * speed * -1;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initRails(scope) {
    (scope || document).querySelectorAll('[data-mp-rail-prev],[data-mp-rail-next]').forEach(function (btn) {
      if (btn.__mp) return; btn.__mp = true;
      btn.addEventListener('click', function () {
        var rail = document.getElementById(btn.getAttribute('aria-controls'));
        if (!rail) return;
        var dir = btn.hasAttribute('data-mp-rail-next') ? 1 : -1;
        rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-mp-tabs]').forEach(function (wrap) {
      if (wrap.__mp) return; wrap.__mp = true;
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight') n = (i + 1) % tabs.length;
          if (k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (n !== null) { e.preventDefault(); select(n); tabs[n].focus(); }
        });
      });
      function select(i) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) { panel.hidden = !on; if (on) initReveal(panel); }
        });
      }
    });
  }

  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-mp-acc-single]').forEach(function (acc) {
      if (acc.__mp) return; acc.__mp = true;
      acc.addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        acc.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });
  }

  function initAll(scope) { initReveal(scope); initRails(scope); initTabs(scope); initAccordions(scope); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); initParallax(); });
  } else { initAll(); initParallax(); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
